module.exports = __webpack_public_path__ + "static/media/icon_sort_down.424e5d52.svg";